import React from "react";
import {
  ControlBar,
  MediaContainer,
  PlayerAudioButton,
  PlayerGetSoundButton,
  PlayerOverlayButton,
  PlayerPlayButton,
  PlayerVideo,
} from "@livelyvideo/video-client-web";

const Player = () => {
  return (
    <MediaContainer>
      <PlayerGetSoundButton />
      <PlayerVideo />
      <ControlBar variant="player">
        <PlayerPlayButton />
        <PlayerAudioButton />
      </ControlBar>
      <PlayerOverlayButton />
    </MediaContainer>
  );
};

export default Player;